import React from "react";
import { useDispatch } from "react-redux";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { setShowTeamSettingSidebar } from "../../../actions/teamSettingSidebar";
import { icon, label } from "../../../config";

/**
 * TeamSettingSidebarHeader component handles the header for the team setting sidebar.
 * @author Bhavana
 */
const TeamSettingSidebarHeader = () => {  
  const dispatch = useDispatch();

  const handleCloseSidebar = () => {
    dispatch(setShowTeamSettingSidebar({ showTeamSettingSidebar: false }));
  };

  return (
    <div className="team-setting-sidebar-header d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
      <div className="header-title">
        <h5 className="mb-0 font-weight-medium">Project settings</h5>
      </div>
      <Tooltip anchorElement="target" position="left" parentTitle="true">
        <button
          id="team-setting-close-btn"
          type="button"
          className="d-flex border-0 outline-none ml-2 bg-transparent cursor-pointer team-setting-close-btn p-1"
          onClick={handleCloseSidebar}
          title={label.CLOSE}>
          {icon.ARROW_FORWARD}
        </button>
      </Tooltip>
    </div>
  );
};

export default TeamSettingSidebarHeader;
